function inPagination() {
    const main = document.querySelector('#page > .content-wrapper');
    const navigationList = document.querySelector('#in-page-nav-list ul');
    const inPageNavOpener = document.getElementById('in-page-nav-opener');
    const mobileNavLinks = document.querySelectorAll( '.inpage-navigation__items a');
    const pagerListItems = navigationList?.querySelectorAll('#in-page-nav-list .list-item a');
    let isAutoScrolling = false;

    if ( ! navigationList || ! pagerListItems || pagerListItems.length === 0 ) return;

    clickPagerListItem(inPageNavOpener, pagerListItems);
    openMobileInPageNav(inPageNavOpener);
    detectSection(main, pagerListItems);

    window.addEventListener('scroll', () => {
        if ( isAutoScrolling ) return;
        detectSection(main, pagerListItems);
    });

    document.addEventListener('smoothScrollComplete', () => {
        isAutoScrolling = false;
    });

    document.addEventListener('inPageNavLinkClicked', () => {
        isAutoScrolling = true;
    });

    mobileNavLinks?.forEach((link) => {
        link.addEventListener('click', () => {
            closeMobileInPageNav(inPageNavOpener);
        });
    });
}

function openMobileInPageNav(inPageNavOpener) {
    inPageNavOpener.addEventListener('click', () => {
        if (matchMedia('(max-width: 1200px)').matches) {
            inPageNavOpener.classList.toggle('active');
        }
    });
}

function closeMobileInPageNav(inPageNavOpener) {
    if (matchMedia('(max-width: 1200px)').matches) {
        inPageNavOpener.classList.remove('active');
    }
}

function clickPagerListItem(inPageNavOpener, pagerListItems) {
    const inPageNavLinkClicked = new CustomEvent('inPageNavLinkClicked');
    
    pagerListItems.forEach((pagerListItem) => {
        pagerListItem.addEventListener('click', (e) => {
            if (e.target.href.substring(0, 1) === '#' ) {
                e.preventDefault();

                document.dispatchEvent(inPageNavLinkClicked);

                inPageNavOpener.classList.remove('active');

                // updateNavTitle(e.target.innerText, e.target.href.split('#')[1]);
            }
        });
    });
}

function isElementNearTop(element, offset = 300) {
    const rect = element.getBoundingClientRect();
    return rect.top <= offset;
}

function detectSection(main, pagerListItems) {
    // different page selectors for people and programs pages
    const ids = main.querySelectorAll('.block-in-page-naviagation .nav-list a');
    const blocks = [];
    ids.forEach(anchor => {
        const href = anchor.getAttribute('href').replace('#', '');
        const block = document.getElementById(href);

        if (block) {
            blocks.push(block);
        }
    });
    let closestToTop, titleText;

    // looping people sections if they exist
    if (blocks.length > 0) {
        // assign the closest section to top and the in-page navigation title
        if (pagerListItems[0]?.innerText.toLowerCase() === 'all') {
            closestToTop = document.body;
            titleText = 'All';
        }
        else {
            closestToTop = blocks[0];
            titleText = closestToTop.id.replace(/-/g, ' ');
        }
        
        blocks.forEach((section) => {
            if (Math.abs(section.getBoundingClientRect().top) < Math.abs(closestToTop.getBoundingClientRect().top)) {
                if (isElementNearTop(section)) {
                    closestToTop = section;
                    titleText = closestToTop.id.replace(/-/g, ' ');
                }
            }
        });
    }

    // remove the current class from all list items
    pagerListItems.forEach((pagerListItem) => {
        pagerListItem.parentElement.classList.remove('current');
    });
    
    // update the in-page navigation title
    // updateNavTitle(titleText, closestToTop);
}

function updateNavTitle(titleText, closestToTop) {
    // get the in-page-navigation title and list
    const pagerTitle = document.getElementById('in-page-nav-title');

    let newActiveListItem;
    if (titleText === 'All') {
        newActiveListItem = document.querySelector(`#in-page-nav-list .list-item a[href="#all"]`);
    }
    else {
        newActiveListItem = document.querySelector(`#in-page-nav-list .list-item a[href="#${closestToTop.id}"]`);
    }

    if (newActiveListItem) {
        newActiveListItem.parentElement.classList.add('current');
    }

    pagerTitle.innerText = titleText;
}

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        inPagination();
    },
    loaded() {},
    resized() {},
    scrolled() {},
    keyDown() {},
    mouseUp() {},
};
export default controller;
  